// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSResuorceListController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$WebTitle',
    function($scope, $stateParams, $rootScope, CMSService, $WebTitle) {

        // --------------------------------
        // 取得更多資源分類資訊
        // --------------------------------
        var loadMoreList = function() {

            if($scope.isLoading || $scope.isEmpty || $scope.isNoMore) {
                return;
            }

            getResourceList();
        }

        // --------------------------------
        // [privete] 取得資源分類資訊
        // --------------------------------
        var getResourceList = function() {

            if($scope.isLoading) {
                return;
            }

            // 切換state時，infinit scroll 會立刻做事，這段是防止在某個分類下會拿到全部未分類的資料
            if($scope.category && (!$scope.categoryItem || $scope.categoryItem.key != $scope.category)) {
                return;
            }

            var id = $scope.categoryItem ? $scope.categoryItem._id : undefined;
            $scope.isLoading = true;

            CMSService.getResourceList(id, $scope.sort, $scope.page).then(function(result) {

                if(result) {

                    if(Array.isArray(result.results) && result.results.length > 0) {
                        Array.prototype.push.apply($scope.rscList, result.results);
                    } else if($scope.rscList.length > 0) {
                        $scope.isNoMore = true;
                    } else if($scope.rscList.length == 0) {
                        $scope.isEmpty = true;
                    }
                    
                } else {
                    $scope.isError = true;
                }

                $scope.page++;
                $scope.isLoading = false;

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // [privete] 取得資源分類列表
        // --------------------------------
        var getResourceCategoryList = function() {

            CMSService.getResourceCategoryList().then(function(result) {

                if(Array.isArray(result) && result.length > 0) {
                    $scope.categoryList = result;
                }
            })
        }

        // --------------------------------
        // [privete] 取得資源分類資訊
        // --------------------------------
        var getResourceCategory = function() {

            if($scope.category) {
                CMSService.getResourceCategory($scope.category).then(function(result) {

                    if(result) {
                        $scope.categoryItem = result;

                        getResourceList();
                    }
                })
            } else {
                getResourceList();
            }

            $WebTitle.setWebTitle('設計資源 | inif印衣服，巧昱服飾設計有限公司');
        }

        var toggleCategoryMenuBar = function() {

            $scope.isShowSortMenu = false;
            $scope.isShowCategoryMenu = !$scope.isShowCategoryMenu;
        }

        var toggleSortMenuBar = function() {

            $scope.isShowCategoryMenu = false;
            $scope.isShowSortMenu = !$scope.isShowSortMenu;
        }

        // --------------------------------
        // 增加 Resource view 數量
        // --------------------------------
        var updateResourceViewCount = function(post) {

            CMSService.updateResourceViewCount(post._id).then(function(result) {

            })
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {
            $scope.page = 1;
            getResourceCategoryList();
            getResourceCategory();
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.page = 1;
        $scope.sort = $stateParams.sort || 'time';
        $scope.category = $stateParams.category;
        $scope.categoryItem;

        $scope.categoryList = [];
        $scope.rscList = [];
        $scope.isLoading = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;
        $scope.isError = false;
        $scope.isShowSortMenu = false;
        $scope.isShowCategoryMenu = false;

        //==========================
        //  Methods
        //==========================
        $scope.loadMoreList = loadMoreList;
        $scope.updateResourceViewCount = updateResourceViewCount; // 增加 Resource view 數量
        $scope.toggleCategoryMenuBar = toggleCategoryMenuBar;
        $scope.toggleSortMenuBar = toggleSortMenuBar;

        //==========================
        //  Init
        //==========================
        init();
    }
]);

// window.InifECMobileApp.directive('masonry', ['$rootScope', '$timeout', function($rootScope, $timeout) {

//     var _dir = {};

//     var link = function(scope, element) {

//         var layout;

//         $timeout(function() {
//             layout = $(element).masonry({
//               // set itemSelector so .grid-sizer is not used in layout
//               itemSelector: '.grid-item',
//               // use element for option
//               // columnWidth: 80, //'.grid-sizer',
//               columnWidth: '.grid-sizer',
//               gutter: 0,
//               percentPosition: true
//             })
//         }, 100);
        
//         scope.$watchCollection("masonry", function(oldValue, newValue) {
//             console.log(oldValue, newValue)
//             $timeout(function() {
//                 layout && layout.masonry('reloadItems');    
//             },100);
//         });

//     };
    
//     _dir.restrict = 'A';
//     _dir.scope = {
//         masonry: "="
//     };
//     _dir.replace = true;
//     _dir.link = link;

//     return _dir;

// }]);
